/* unplugin-vue-components disabled */import script from "./evaluationGradeSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./evaluationGradeSettings.vue?vue&type=script&setup=true&lang=js"

import "./evaluationGradeSettings.vue?vue&type=style&index=0&id=c5e7297a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5e7297a"]])

export default __exports__